import { render } from "./VisualizzaSala.vue?vue&type=template&id=0e3e3354&scoped=true"
import script from "./VisualizzaSala.vue?vue&type=script&lang=js"
export * from "./VisualizzaSala.vue?vue&type=script&lang=js"

import "./VisualizzaSala.vue?vue&type=style&index=0&id=0e3e3354&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3e3354"]])

export default __exports__